<template>
  <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g clip-path="url(#clip0_2832_7064)">
      <path
        d="M3.33301 5.99992L1.33301 7.99992M1.33301 7.99992L3.33301 9.99992M1.33301 7.99992H14.6663M5.99967 3.33325L7.99967 1.33325M7.99967 1.33325L9.99967 3.33325M7.99967 1.33325V14.6666M9.99967 12.6666L7.99967 14.6666M7.99967 14.6666L5.99967 12.6666M12.6663 5.99992L14.6663 7.99992M14.6663 7.99992L12.6663 9.99992"
        stroke="currentColor"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </g>
    <defs>
      <clipPath id="clip0_2832_7064">
        <rect width="16" height="16" fill="white" />
      </clipPath>
    </defs>
  </svg>
</template>
